import { InviteLinkButton, AppVersion } from '@app/shared/ui/atoms/Common';

interface InviteLinkWithVersionSectionProps {
  onClick: () => void;
}

export const InviteLinkWithVersionSection = ({ onClick }: InviteLinkWithVersionSectionProps) => {
  return (
    <section className="space-y-2">
      <InviteLinkButton onClick={onClick} />
      <AppVersion />
    </section>
  );
};
